<template>
  <teleport to="body">
    <div
      class="orm-html orm-modal orm-modal--stationtime orm-modal--overflowAuto"
    >
      <div class="orm-container">
        <div class="orm-row center-xs middle-xs orm-h100vh">
          <div class="orm-col-xs-12 orm-col-sm-10 orm-col-md-6 orm-col-lg-4">
            <div
              class="orm-modal__inner orm-modal__inner--fullheight orm-pt-60 orm-pb-30 orm-px-8 orm-px-xs-30 orm-relative"
            >
              <span
                v-if="!loading"
                @click="cancel()"
                class="btn__small--black btn__small--topright float-right"
              >
                <i class="fas fa-times"></i>
              </span>
              <div class="orm-row">
                <div class="orm-col-xs-12">
                  <FormSelect
                    v-if="
                      sttype == 'ALL' &&
                        tabbar &&
                        stations &&
                        tabbar.length > 1 &&
                        !isCarTab
                    "
                    :data="tabbar"
                    :selected="stationtype"
                    v-model="stationtype"
                    @update:modelValue="setStationType(stationtype)"
                  ></FormSelect>
                  <Stationpicker
                    v-if="stations"
                    :data="stations"
                    :readonly="noSelect"
                    type="start"
                    :enabled-stations="car.enabled_stations"
                    v-model:selectedstation="selectedStation"
                  />
                  <Stationpicker
                    :data="stations"
                    type="end"
                    v-if="
                      stations &&
                        store.getters['ORMgeneral/GET_PARAMETER'](
                          'BINET_ALLOW_ONEWAY'
                        ) == 1 &&
                        stationtype != 'ABO'
                    "
                  />
                </div>
                <div class="orm-relative orm-col-xs-12">
                  <Datepicker
                    :infobar="false"
                    viewType="mapModule"
                    :is-offer="isOffer"
                    v-if="stationtype !== 'ABO'"
                  />
                  <Datepicker_abo
                    :infobar="false"
                    viewType="mapModule"
                    :is-offer="isOffer"
                    :carAboLengthOptions="carAboLengthOptions"
                    v-else
                  />
                </div>
                <div
                  class="orm-relative orm-col-xs-12 orm-mb-16"
                  v-if="store.getters['ORMgeneral/GET_PARAMETER'](
                        'BORM_PRESELECT_PLANNED_KM'
                      ) === '1' && stationtype !== 'ABO'"
                >
                  <div class="orm-searchbar__headline">
                    {{
                      i18n("general/plannedDistance") || "Geplante Kilometer"
                    }}
                  </div>
                  <KmInput />
                </div>
                <div class="orm-relative orm-col-xs-12">
                  <button
                      v-if="!loading"
                      @click="getCars('/reservation/step1')"
                      class="orm-btn orm-btn--large orm-btn--searchbar"
                      :class="[station ? '' : 'disable']"
                      :disabled="!station"
                  >
                    {{ i18n("general/showOffers") }}
                  </button>
                  <button
                      class="orm-btn orm-btn--large orm-btn--searchbar disable"
                      v-else
                  >
                    <i class="fa fa-spinner-third orm-rotate360"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>
<script>
// import routes from "@/router/index";
// eslint-disable-next-line
import store from "@/store";
import Datepicker from "@/components/ui/datepicker.vue"; // @ is an alias to /src
import Datepicker_abo from "@/components/ui/datepicker_abo.vue"; // @ is an alias to /src
import FormSelect from "@/components/ui/INPUTS/FormSelectSimpleArray"; // @ is an alias to /src
import Stationpicker from "@/components/ui/stationpicker.vue"; // @ is an alias to /src
import KmInput from "@/components/ui/km-input.vue";
import i18n from "@/mixins/mixins";
import { buildDataLayer } from "@/constants/analytics";
import { routeToSteps } from "@/constants/getRoutes";

export default {
  name: "modal-stationtimeselect",
  components: {
    Datepicker,
    Datepicker_abo,
    Stationpicker,
    FormSelect,
    KmInput,
  },
  emits: ["cancel"],
  props: {
    car: Object,
    showCategory: {
      type: Boolean,
      required: false,
      default: false,
    },
    multiCategories: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableCarfilter: {
      type: Boolean,
      required: false,
      default: false,
    },
    sttype: {
      type: String,
      required: false,
      default: "ALL",
    },
    isOffer: {
      type: Boolean,
      required: false,
      default: false,
    },
    noSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    isCarTab: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [i18n],
  data() {
    return {
      loading: false,
      selectedStation: null,
      stationtype: "ALL",
      stations: null,
      stationsAll: null,
      tabbar: [],
      station: null,
      carAboLengthOptions: null,
    };
  },
  setup() {
    // const stations = store.getters["stations/GET_STATIONS"];
    // const station = store.getters["userSession/GET_STATION"];
    const env = process.env;
    return {
      store,
      env,
    };
  },
  async mounted() {
    if (!this.isCarTab && this.car.prices) {
      this.loading = true;
      this.carAboLengthOptions = this.car.prices.map((obj) => obj.months);
      const targetMonths = await store.getters["reservation/GET_SELECTEDABO"];
      if (
        !(await this.car.prices.some(
          (obj) => obj.months === Number(targetMonths[0])
        ))
      ) {
        await store.dispatch("reservation/SET_ABOLENGTH", [
          this.car.prices[0].months.toString(),
          (await store.getters["ORMgeneral/GET_PARAMETER"](
            "SORM_DATE_END_VALUE"
          )) * this.car.prices[0].months,
        ]);
        await store.dispatch("stations/SET_OPENINGTIMES");
      }
      this.loading = false;
    }

    if (store.getters['ORMgeneral/GET_PARAMETER'](
        'BORM_PRESELECT_STATION'
    ) === '1') {
      this.station = await store.getters["userSession/GET_STATION"];
    }
    this.stationtype = await store.getters["userSession/GET_STATIONTYPE"];
    this.stationsAll = await store.getters["stations/GET_STATIONS_FILTERED"];

    this.stations = this.stationsAll[this.stationtype];

    const enabled = this.car.enabled_stations;

    if (enabled) {
      for (const type in this.stationsAll) {
        if (
          Object.hasOwnProperty.call(this.stationsAll, type) &&
          type !== "ALL"
        ) {
          for (const key in enabled) {
            const enabledkey = enabled[key];
            const check = this.stationsAll[type].find(
              (x) => x.id == enabledkey
            );
            if (check) {
              this.tabbar.indexOf(type) === -1 ? this.tabbar.push(type) : "";
            }
          }
        }
      }
      if (this.tabbar.indexOf(this.stationtype) === -1) {
        if (store.getters['ORMgeneral/GET_PARAMETER'](
            'BORM_PRESELECT_STATION'
        ) === '1') {
            store.dispatch(
            "userSession/SET_STATION",
            this.stationsAll[this.tabbar[0]][0].id
          );
        }
        store.dispatch("userSession/SET_STATIONTYPE", this.tabbar[0]);
        this.stations = this.stationsAll[this.tabbar[0]];
        this.stationtype = this.tabbar[0];
      }
    }
    if (this.isOffer) {
      const FilteredOfferStation = [];
      for (const key in enabled) {
        const enabledkey = enabled[key];
        const check = this.stationsAll[this.stationtype].find(
          (x) => x.id == enabledkey
        );
        if (check) {
          FilteredOfferStation.push(check);
        }
      }
      this.stations = FilteredOfferStation;
    }

    // for (const station in this.stationsAll) {
    //   if (station !== "ALL") this.tabbar.push(station);
    // }

    store.watch(
        // eslint-disable-next-line
        (state, getters) => getters["userSession/GET_STATION"],
        (val) => {
          this.station = store.getters["stations/GET_STATION_BY_ID"](val);
        }
    );

    document.body.style.overflow = "hidden";
  },
  beforeUnmount() {
    document.body.style.overflow = "unset";
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async getCars() {
      this.loading = true;
      // if (this.selectedStation) {
      //   store.dispatch("userSession/SET_STATION", this.selectedStation);
      // }
      const times = await store.getters["stations/GET_OPENINGTIMES"];
      this.loading = true;
      if (times) {
        buildDataLayer("orm_reservation_begin", {}, "carcategoryslider");
        if (this.showCategory) {
          const group = {};
          if (!this.disableCarfilter || this.stationtype != "ABO") {
            if (this.multiCategories) {
              this.car.category.forEach((element) => {
                group[element] = true;
              });
            } else {
              group[this.car.category] = true;
            }
          } else {
            group[this.car.vehicle_group.vehicle_category[0].id] = true;
          }

          store.dispatch("userSession/SET_CARCATEGORY", group);

          routeToSteps(this, 1);
        } else {
          store.dispatch("userSession/SET_CARGROUP", this.car.id).then(() => {
            store.dispatch("reservation/DELETE_TARIF");
            store.dispatch("stations/SET_OPENINGTIMES").then(() => {
              store
                .dispatch("reservation/CALCULATE_PRICE", {
                  id: this.car.id,
                  extras: false,
                })
                .then((tarif) => {
                  if (tarif.main_rates.length == 0) {
                    routeToSteps(this, 1);
                  } else {
                    store
                      .dispatch("reservation/SET_RESERVATION_TARIFS", tarif)
                      .then(() => {
                        routeToSteps(this, 2);
                      });
                  }
                });
            });
          });
        }
      }
    },
    async setStationType(type) {
      this.stationtype = type;
      await store.dispatch("userSession/SET_STATIONTYPE", type).then(() => {
        if (store.getters['ORMgeneral/GET_PARAMETER'](
            'BORM_PRESELECT_STATION'
        ) === '1') {
          store.dispatch("userSession/SET_STATION", this.stationsAll[type][0].id);
        }
        store.dispatch("userSession/SET_STATION_END", "startend");
        this.stations = null;
        this.stations = this.stationsAll[type];
      });
    },
  },
};
</script>
